<template>
    <div id="bst-wrap">
        <div class="l-project-wrap l-project-wrap--login">

            <section class="l-content-area">
                <div class="l-content">

                    <section class="p-bloc p-bloc--register">
                        <div class="p-bloc__content l-wrap__outer">
                            <div class="l-wrap__inner">

                                <div class="login-box">

                                    <div class="p-login__title">
                                        <div class="logo"><img src="@/assets/img/login/logo.png" alt="hubsynch"></div>
                                        <h1>{{ $t('LABEL_REGISTER_ACCOUNT') }}</h1>
                                    </div>

                                    <!-- register -->
                                    <section class="p-register c-register-parts" ref="inputRef">
                                        <p>{{ $t('LABEL_INSERT_REQUIRED_FIELDS') }}</p>

                                        <form>
                                            <div class="p-register__form p-register__form--input">

                                                <div class="is-error"
                                                    v-if="userStore.editAccountParamsErrorMsg !== null">
                                                    <p class=" error-txt">{{ userStore.editAccountParamsErrorMsg }}</p>
                                                </div>

                                                <dl class="mailaddress">
                                                    <dt>{{ $t('LABEL_EMAIL') }}</dt>
                                                    <dd>
                                                        <p>{{ sessionStore.session_data['email'] }}</p>
                                                    </dd>
                                                </dl>

                                                <dl class="region">
                                                    <dt>{{ $t("LABEL_REGION") }}</dt>
                                                    <dd>
                                                        <ul class="radio-area">
                                                            <!-- TODO: When there is an error, add "is-error" class to this "ul.radio-area" -->
                                                            <li><input id="edit-input-region-japan" type="radio"
                                                                    name="region" :value="false"
                                                                    v-model="userStore.isOverseasUser" checked><label
                                                                    for="edit-input-region-japan"><span>{{
                                                                        $t("LABEL_JAPAN") }}</span></label></li>
                                                            <li><input id="edit-input-region-overseas" type="radio"
                                                                    name="region" :value="true"
                                                                    v-model="userStore.isOverseasUser"><label
                                                                    for="edit-input-region-overseas"><span>{{
                                                                        $t("LABEL_OVERSEAS")
                                                                    }}</span></label></li>
                                                        </ul>
                                                        <p class="error-txt">{{ $t("LABEL_CHOOSE_REGION") }}</p>
                                                    </dd>
                                                </dl>
                                                <dl class="name">
                                                    <dt>{{ $t('LABEL_NAME') }}<span>{{ $t('LABEL_REQUIRED') }}</span>
                                                    </dt>
                                                    <dd>
                                                        <ul class="input-area"
                                                            :class="{ 'is-error': v$.last_name.$error || v$.first_name.$error || v$.full_name.$error || userStore.editAccountErrors.last_name || userStore.editAccountErrors.first_name }">
                                                            <!-- TODO: When there is an error, add "is-error" class to this "ul.input-area" -->
                                                            <li v-if="!userStore.isOverseasUser"><input type="text"
                                                                    name="last_name" id="last_name"
                                                                    v-model="userStore.editAccountParams.last_name"
                                                                    class="plchldr" :placeholder="$t('LABEL_LAST_NAME')"
                                                                    required></li>
                                                            <li v-if="!userStore.isOverseasUser"><input type="text"
                                                                    name="first_name" id="first_name"
                                                                    v-model="userStore.editAccountParams.first_name"
                                                                    class="plchldr"
                                                                    :placeholder="$t('LABEL_FIRST_NAME')" required></li>
                                                            <li v-if="userStore.isOverseasUser"><input type="text"
                                                                    name="full_name" id="full_name"
                                                                    v-model="userStore.editAccountParams.full_name"
                                                                    class="plchldr" :placeholder="$t('LABEL_FULL_NAME')"
                                                                    required></li>
                                                        </ul>
                                                        <p class="error-txt" v-if="v$.last_name.$errors[0]">{{
                                                            $t(v$.last_name.$errors[0].$message) }}</p>
                                                        <p class="error-txt" v-if="v$.first_name.$errors[0]">{{
                                                            $t(v$.first_name.$errors[0].$message) }}</p>
                                                        <p class="error-txt" v-if="v$.full_name.$errors[0]">{{
                                                            $t(v$.full_name.$errors[0].$message) }}</p>
                                                        <p class="error-txt">{{ userStore.editAccountErrors.last_name }}
                                                        </p>
                                                        <p class="error-txt">{{ userStore.editAccountErrors.first_name
                                                            }}</p>
                                                    </dd>
                                                </dl>

                                                <dl v-if="!userStore.isOverseasUser" class="kana">
                                                    <dt>{{ $t('LABEL_FURIGANA') }}<span>{{ $t('LABEL_REQUIRED')
                                                            }}</span></dt>
                                                    <dd>
                                                        <ul class="input-area"
                                                            :class="{ 'is-error': v$.last_name_kana.$error || v$.first_name_kana.$error || userStore.editAccountErrors.last_name_kana || userStore.editAccountErrors.first_name_kana }">
                                                            <!-- TODO: When there is an error, add "is-error" class to this "ul.input-area" -->
                                                            <li><input type="text" name="last_name_kana"
                                                                    id="last_name_kana"
                                                                    v-model="userStore.editAccountParams.last_name_kana"
                                                                    class="plchldr"
                                                                    :placeholder="$t('LABEL_LAST_NAME_KANA')" required>
                                                            </li>
                                                            <li><input type="text" name="first_name_kana"
                                                                    id="first_name_kana"
                                                                    v-model="userStore.editAccountParams.first_name_kana"
                                                                    class="plchldr"
                                                                    :placeholder="$t('LABEL_FIRST_NAME_KANA')" required>
                                                            </li>
                                                        </ul>
                                                        <p class="error-txt" v-if="v$.last_name_kana.$errors[0]">{{
                                                            $t(v$.last_name_kana.$errors[0].$message) }}</p>
                                                        <p class="error-txt" v-if="v$.first_name_kana.$errors[0]">{{
                                                            $t(v$.first_name_kana.$errors[0].$message) }}</p>
                                                        <p class="error-txt">{{
                                                            userStore.editAccountErrors.last_name_kana }}</p>
                                                        <p class="error-txt">{{
                                                            userStore.editAccountErrors.first_name_kana }}</p>
                                                    </dd>
                                                </dl>

                                                <dl class="birth">
                                                    <dt>{{ $t('LABEL_BIRTHDATE') }}<span>{{ $t('LABEL_REQUIRED')
                                                            }}</span></dt>
                                                    <dd>
                                                        <div class="input-area"
                                                            :class="{ 'is-error': v$.birthday.$error || userStore.editAccountErrors.birthday }">
                                                            <!-- TODO: When there is an error, add "is-error" class to this "div.input-area" -->
                                                            <input type="tel" name="birthday" id="birthday"
                                                                v-model="userStore.editAccountParams.birthday"
                                                                @input="formatDate" class="plchldr"
                                                                placeholder="YYYY-MM-DD" pattern="^[0-9\-]+$"
                                                                maxlength="10" required>
                                                        </div>
                                                        <p class="sub-txt">{{ $t('LABEL_INPUT_DATE_FORMAT') }}</p>
                                                        <p class="error-txt" v-if="v$.birthday.$errors[0]">{{
                                                            $t(v$.birthday.$errors[0].$message) }}</p>
                                                        <p class="error-txt">{{ userStore.editAccountErrors.birthday }}
                                                        </p>
                                                    </dd>
                                                </dl>

                                                <dl class="sex">
                                                    <dt>{{ $t('LABEL_GENDER') }}<span>{{ $t('LABEL_REQUIRED') }}</span>
                                                    </dt>
                                                    <dd>
                                                        <ul class="radio-area"
                                                            :class="{ 'is-error': v$.sex.$error || userStore.editAccountErrors.sex }">
                                                            <!-- TODO: When there is an error, add "is-error" class to this "ul.radio-area" -->
                                                            <li><input type="radio"
                                                                    v-model="userStore.editAccountParams.sex" id="man"
                                                                    name="sex" value="1"><label for="man"><span>{{
                                                                        $t('LABEL_MAN') }}</span></label></li>
                                                            <li><input type="radio"
                                                                    v-model="userStore.editAccountParams.sex" id="woman"
                                                                    name="sex" value="2"><label for="woman"><span>{{
                                                                        $t('LABEL_FEMALE') }}</span></label></li>
                                                            <li><input type="radio"
                                                                    v-model="userStore.editAccountParams.sex" id="other"
                                                                    name="sex" value="3"><label for="other"><span>{{
                                                                        $t('LABEL_NOT_SELECT') }}</span></label></li>
                                                        </ul>
                                                        <p class="error-txt" v-if="v$.sex.$errors[0]">{{
                                                            $t(v$.sex.$errors[0].$message) }}</p>
                                                        <p class="error-txt">{{ userStore.editAccountErrors.sex }}</p>
                                                    </dd>
                                                </dl>

                                                <dl class="telephone">
                                                    <dt>{{ $t('LABEL_PHONE_NUMBER') }}<span>{{ $t('LABEL_REQUIRED')
                                                            }}</span></dt>
                                                    <dd>
                                                        <div class="input-area"
                                                            :class="{ 'is-error': v$.tel.$error || userStore.editAccountErrors.tel }">
                                                            <!-- TODO: When there is an error, add "is-error" class to this "div.input-area" -->
                                                            <input type="tel" name="tel" id="tel"
                                                                v-model="userStore.editAccountParams.tel"
                                                                class="plchldr" placeholder="0300000000" required>
                                                        </div>
                                                        <p class="sub-txt">{{ $t('LABEL_HYPHEN_NOT_REQUIRED') }}</p>
                                                        <p class="error-txt" v-if="v$.tel.$errors[0]">{{
                                                            $t(v$.tel.$errors[0].$message) }}</p>
                                                        <p class="error-txt">{{ userStore.editAccountErrors.tel }}</p>
                                                    </dd>
                                                </dl>
                                                <dl v-if="userStore.isOverseasUser" class="country">
                                                    <dt>{{ $t("LABEL_COUNTRY") }}</dt>
                                                    <dd>
                                                        <div class="select-area"
                                                            :class="{ 'is-error': v$.country.$error || userStore.editAccountErrors.country }">
                                                            <!-- TODO: When there is an error, add "is-error" class to this "ul.select-area" -->
                                                            <span class="select-box">
                                                                <select name="country" id="country"
                                                                    v-model="userStore.editAccountParams.country"
                                                                    required>
                                                                    <option :value="v.id"
                                                                        v-for="(v, i) in userStore.countries" :key="i">
                                                                        {{ v.name }}</option>
                                                                </select>
                                                            </span>
                                                        </div>
                                                        <p class="error-txt" v-if="v$.country.$errors[0]">{{
                                                            $t(v$.country.$errors[0].$message) }}</p>
                                                    </dd>
                                                </dl>

                                                <dl class="zipcode">
                                                    <dt>{{ $t('LABEL_ZIP_CODE') }}<span>{{ $t('LABEL_REQUIRED')
                                                            }}</span></dt>
                                                    <dd>
                                                        <div class="input-area"
                                                            :class="{ 'is-error': v$.zip_code.$error || userStore.editAccountErrors.zip_code }">
                                                            <input type="text" name="zip_code" id="zip_code"
                                                                v-model="userStore.editAccountParams.zip_code"
                                                                class="plchldr" maxlength="7"
                                                                @input="userStore.editAccountParams.zip_code = userStore.editAccountParams.zip_code.replace(/\D/g, '')"
                                                                placeholder="0000000"
                                                                @keyup="zipCodeChangeInEdit(userStore.editAccountParams.zip_code)"
                                                                required>
                                                        </div>
                                                        <p class="sub-txt">{{ $t('LABEL_ZIP_CODE_OVERSEAS') }}</p>
                                                        <p class="error-txt" v-if="v$.zip_code.$errors[0]">{{
                                                            $t(v$.zip_code.$errors[0].$message) }}</p>
                                                        <p class="error-txt">{{ userStore.editAccountErrors.zip_code }}
                                                        </p>
                                                    </dd>
                                                </dl>

                                                <dl v-if="!userStore.isOverseasUser" class="address1">
                                                    <dt>{{ $t('LABEL_ADDRESS_1') }}<span>{{ $t('LABEL_REQUIRED')
                                                            }}</span></dt>
                                                    <dd>
                                                        <div class="select-area"
                                                            :class="{ 'is-error': v$.address_1.$error || userStore.editAccountErrors.address_1 }">
                                                            <span class="select-box">
                                                                <select name="address_1" id="address_1"
                                                                    v-model="userStore.editAccountParams.address_1"
                                                                    required>
                                                                    <option :value="i" v-for="(v, i) in PREFECTURES_JA">
                                                                        {{ v }}</option>
                                                                </select>
                                                            </span>
                                                        </div>
                                                        <p class="error-txt" v-if="v$.address_1.$errors[0]">{{
                                                            $t(v$.address_1.$errors[0].$message) }}</p>
                                                        <p class="error-txt">{{ $t('LABEL_SELECT_PREFECTURE') }}</p>
                                                    </dd>
                                                </dl>

                                                <dl class="address2">
                                                    <dt>{{ $t('LABEL_ADDRESS_2') }}<span>{{ $t('LABEL_REQUIRED')
                                                            }}</span></dt>
                                                    <dd>
                                                        <div class="input-area"
                                                            :class="{ 'is-error': v$.address_2.$error || userStore.editAccountErrors.address_2 }">
                                                            <input type="text" name="address_2" id="address_2"
                                                                v-model="userStore.editAccountParams.address_2"
                                                                class="plchldr" :placeholder="$t('LABEL_ADDRESS_2')"
                                                                required>
                                                        </div>
                                                        <p class="error-txt" v-if="v$.address_2.$errors[0]">{{
                                                            $t(v$.address_2.$errors[0].$message) }}</p>
                                                        <p class="error-txt">{{ userStore.editAccountErrors.address_2 }}
                                                        </p>
                                                    </dd>
                                                </dl>

                                                <dl class="address3">
                                                    <dt>{{ $t('LABEL_ADDRESS_3') }}<span>{{ $t('LABEL_REQUIRED')
                                                            }}</span></dt>
                                                    <dd>
                                                        <div class="input-area"
                                                            :class="{ 'is-error': v$.address_3.$error || userStore.editAccountErrors.address_3 }">
                                                            <input type="text" name="address_3" id="address_3"
                                                                v-model="userStore.editAccountParams.address_3"
                                                                class="plchldr" :placeholder="$t('LABEL_ADDRESS_3')"
                                                                required>
                                                        </div>
                                                        <p class="error-txt" v-if="v$.address_3.$errors[0]">{{
                                                            $t(v$.address_3.$errors[0].$message) }}</p>
                                                        <p class="error-txt">{{ userStore.editAccountErrors.address_3 }}
                                                        </p>
                                                    </dd>
                                                </dl>
                                            </div>

                                            <div class="p-register__btn">
                                                <div class="c-btn c-btn--regist-next"><input type="button"
                                                        :value="$t('LABEL_BUTTON_CONFIRM_INPUTS')"
                                                        @click="editAccount()"></div>
                                            </div>

                                            <div class="p-register__back">
                                                <div class="c-btn c-btn--tologin"><button type="button"
                                                        @click="logOut">{{ $t('LABEL_BUTTON_TO_LOGIN_PAGE') }}</button>
                                                </div>
                                            </div>
                                        </form>
                                    </section><!-- .p-register -->

                                </div><!-- .bg-box -->

                            </div>
                        </div>
                    </section>


                </div><!-- .l-content -->
            </section><!-- .l-content-area -->

        </div><!-- .l-project-wrap -->

        <!-- footer -->

    </div>

</template>

<script setup>
import { useSessionStore } from "@/stores/sessionStore";
import { useUserStore } from "@/stores/userStore";
import { useVuelidate } from "@vuelidate/core";
import { getEditAccountRules } from "@/validations/userRegisterValidation";
import { ref } from "vue";
import router from "@/router";
import { onMounted } from "vue";
import { useI18n } from 'vue-i18n';
import { PREFECTURES_JA } from "@/data/constants";
import * as addressUtility from "@/helpers/addressUtility";

const { t } = useI18n();

const sessionStore = useSessionStore();
const userStore = useUserStore();

const inputRef = ref();

const v$ = useVuelidate(getEditAccountRules(userStore, t), userStore.editAccountParams);

onMounted(async () => {
    await userStore.getCountries();
    if (userStore.countries.length > 0) {
        userStore.editAccountParams.country = userStore.countries[0].id;
    }
});

async function editAccount() {
    if (!await v$.value.$validate()) {
        inputRef.value.scrollIntoView({ behavior: "smooth" });
        return false;
    }

    await router.push({ name: 'edit.account.confirm' })
}

const formatDate = () => {
    userStore.editAccountParams.birthday = userStore.editAccountParams.birthday
        .replace(/\D/g, "") // Remove non-digits
        .slice(0, 8) // Limit to 8 characters
        .replace(/(\d{4})(\d{2})?(\d{2})?/, (_, y, m, d) =>
            [y, m, d].filter(Boolean).join("-")
        );
};

function zipCodeChangeInEdit() {
    if (!userStore.isOverseasUser && userStore.editAccountParams.zip_code !== null && /^\d+$/.test(userStore.editAccountParams.zip_code.toString())) {
        addressUtility.zipCodeAutoComplete(userStore.editAccountParams, userStore.editAccountParams.zip_code.toString());
    }
}

async function logOut() {
    await sessionStore.logOut();
    router.push({ name: "login" });
}
</script>